import React from 'react'
import { Box, Box as CardContainer, Illustration } from '@node-space/ui-components'

export const StatusCardState = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const
export type StatusCardStateType = (typeof StatusCardState)[keyof typeof StatusCardState]

export interface StatusCardProps {
  headline: string
  description?: React.ReactNode
  children?: React.ReactNode
  ActionButtons?: React.ReactNode
  testid?: string
  status?: StatusCardStateType
  customIcon?: React.ReactNode
  className?: string
}

export const SheetStatusCard = ({
  headline,
  description,
  children,
  ActionButtons,
  testid,
  status,
  customIcon,
  className,
}: StatusCardProps) => {
  const hasIcon = !!status || !!customIcon

  const getStateIcon = () => {
    if (status === StatusCardState.ERROR) {
      return <Illustration name="CloudLightning" color="error" />
    }
    if (status === StatusCardState.SUCCESS) {
      return <Illustration name="HandsClapping" color="success" />
    }
    return <></>
  }

  return (
    <CardContainer
      flexCol
      justify="center"
      className={`py-14 px-6 ${className}`}
      gapY={16}
      data-testid={testid}
    >
      <Box flex centerChildren>
        {hasIcon && (customIcon ?? getStateIcon())}
      </Box>
      <h1 className="text-h1 text-foreground-prominent text-center">{headline}</h1>
      {description && (
        <p className="text-body-regular text-foreground-subdued text-center">{description}</p>
      )}

      <Box flexCol gapY={12}>
        {children}
      </Box>

      <Box flex centerChildren gapX={12} className="mt-2">
        {ActionButtons}
      </Box>
    </CardContainer>
  )
}
